import * as React from 'react';

import { EmptyGuid, NotePurposeTypesEnum } from '../../../utilities/Constants';
import { INoteConversationModel, INoteModel } from '../../../interfaces/INote';

import Common from '../../../stores/Common';
import { Stack } from 'react-bootstrap';

export interface INoteEditorChatProps {
    currentNote: INoteModel;
    onAddMessage: (message: string) => void;
    outerChatBoxHeight?: string;
    readonly?: boolean;
}

export function NoteEditorChat(props: INoteEditorChatProps) {
    if (props.currentNote.purpose?.id === NotePurposeTypesEnum.Info) {
        return null;
    }

    const [newMessage, setNewMessage] = React.useState<string>('');

    const handleNewMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNewMessage(e.target.value);
    };

    const handleAddMessageClick = () => {
        setNewMessage('');
        props.onAddMessage(newMessage);
    };

    if (props.readonly) {
        return (
            <div>
                <label className="text-gray">Chat</label>
                <div className="border-gray" style={{ height: props.outerChatBoxHeight }}>
                    <div
                        className="thin-bottom-border"
                        style={{
                            height: props.outerChatBoxHeight,
                            overflowY: 'auto',
                            padding: '10px',
                        }}
                    >
                        {props.currentNote.conversations?.map(
                            (item: INoteConversationModel, i: number) => {
                                return (
                                    <div key={i} className="padding-bottom-med">
                                        <MessageInfo message={item} />
                                        <div>{item.text}</div>
                                    </div>
                                );
                            }
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            id="NoteChatSection"
            className="col-sm-3"
            style={{ position: 'relative', left: 0, top: 0 }}
        >
            {props.currentNote.purpose?.id !== NotePurposeTypesEnum.Info && (
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '0 12px',
                    }}
                >
                    <label className="text-gray">Chat</label>
                    <div
                        className="border-gray border-bottom-0"
                        style={{
                            overflowY: 'auto',
                            padding: '10px',
                            flexGrow: 1,
                        }}
                    >
                        {props.currentNote.conversations?.map(
                            (item: INoteConversationModel, i: number) => {
                                return (
                                    <div className="padding-bottom-med" key={i}>
                                        <MessageInfo message={item} />
                                        <div>{item.text}</div>
                                    </div>
                                );
                            }
                        )}
                    </div>
                    <div className="border-gray" style={{ display: 'flex' }}>
                        <textarea
                            className="form-control fill-light-gray only-right-border"
                            value={newMessage}
                            name="newChatMessage"
                            rows={4}
                            onChange={handleNewMessageChange}
                            maxLength={30000}
                        />
                        <button className="btn btn-no-bg" onClick={handleAddMessageClick}>
                            <i className="fal fa-lg fa-share-all font-orange" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

function MessageInfo(props: { message: INoteConversationModel }) {
    const { message } = props;

    return (
        <Stack direction="horizontal" style={{ columnGap: '0.5rem', flexWrap: 'wrap' }}>
            <label className="bold">
                {message.author!.profile!.firstName} {message.author!.profile!.lastName}
            </label>
            {message.guid !== EmptyGuid && (
                <span className="nowrap" style={{ fontSize: '0.9em', opacity: 0.6 }}>
                    {Common.dateTimeFormat(message.dateUTC)}
                </span>
            )}
        </Stack>
    );
}
